import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const errMsg = (e) => e?.response?.data?.detail || "Something went wrong";

export const imgSrc = (url) => (url?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads", fd);
  return data;
}

export async function uploadFile(file, kind, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const url = kind === "video" ? "/uploads/video" : kind === "document" ? "/uploads/document" : "/uploads";
  const { data } = await api.post(url, fd, {
    onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
  });
  return data;
}
